import axios from 'axios';
import { handleAxiosError } from 'core/notifications';

export default async ({ id, type }) => {
  const apiType = type === 'live' ? 'live_videos' : 'videos';
  try {
    const { data } = await axios.get(`/api/learner/${apiType}/${id}/related_content`);
    return data.data.related_courses;
  } catch(error) {
    handleAxiosError(error);
  }
};
